import AssignmentUnitsResourceInstance from "../../../../resources/expapiunified/AssignmentUnits.unified.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  AssignmentUnitsResourceInstance,
  "assignment-units",
  (state) => state.assignmentUnits
);
const { actions, epic, reducer, matchers, selectors, getDefaultReducerState } = builder.create();
const {
  selectGetAsyncRequest: selectGetAssignmentUnitAsyncRequest,
  selectQueryAsyncRequest: selectQueryAssignmentUnitsAsyncRequest,
  selectAll: selectAllAssignmentUnits,
  selectById: selectAssignmentUnitById
} = selectors;
const { queryAsync: queryAssignmentUnitsAsync, getAsync: getAssignmentUnit } = actions;
export {
  epic as assignmentUnitsEpic,
  matchers as assignmentUnitsMatchers,
  reducer as assignmentUnitsReducer,
  getAssignmentUnit,
  getDefaultReducerState as getDefaultAssignmentUnitsReducerState,
  queryAssignmentUnitsAsync,
  selectAllAssignmentUnits,
  selectAssignmentUnitById,
  selectGetAssignmentUnitAsyncRequest,
  selectQueryAssignmentUnitsAsyncRequest
};
//# sourceMappingURL=assignment-units.js.map
